const STEPS = [
  {
    num: '01',
    icon: 'ri-search-eye-line',
    title: 'Inspection',
    desc: 'We visit the site and evaluate the subfloor condition, moisture levels, and existing surface. No guessing — every project starts with facts.',
    detail: 'Moisture testing included',
  },
  {
    num: '02',
    icon: 'ri-tools-line',
    title: 'Preparation',
    desc: 'Subfloor leveling, repairs, and corrections are completed before any flooring goes down. This step defines the long-term result.',
    detail: 'Self-leveling & grinding',
  },
  {
    num: '03',
    icon: 'ri-ruler-line',
    title: 'Layout & Planning',
    desc: 'We plan the exact layout, direction, and pattern of the floor. Precise measurements eliminate waste and guarantee a clean finish.',
    detail: 'Zero-waste measurement',
  },
  {
    num: '04',
    icon: 'ri-hammer-line',
    title: 'Installation',
    desc: 'Boards are installed with proper spacing, adhesive, or fasteners depending on the floor type. Every row checked for level and alignment.',
    detail: 'Every row inspected',
  },
  {
    num: '05',
    icon: 'ri-scissors-cut-line',
    title: 'Trim & Transitions',
    desc: 'Baseboards, transitions, and moldings are fitted cleanly. No gaps, no lifting edges — just a complete, finished look.',
    detail: 'Clean edge finishing',
  },
  {
    num: '06',
    icon: 'ri-checkbox-circle-line',
    title: 'Final Quality Check',
    desc: 'We walk the entire floor before we leave. Any imperfection is fixed on the spot. You don\'t sign off until it\'s perfect.',
    detail: 'Full walkthrough with client',
  },
];

export default function ProcessSteps() {
  return (
    <section className="py-24 px-4 md:px-8 bg-[#1c1c1c]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-4">How We Work</p>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-5">Our Installation Process</h2>
          <p className="text-white/45 text-base max-w-xl mx-auto leading-relaxed">
            Six steps. No shortcuts. Every project follows the same systematic process — because consistency is how we guarantee results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {STEPS.map((step, idx) => (
            <div
              key={step.num}
              className="group relative bg-[#1a1a1a] border border-white/8 hover:border-[#c9a55a]/30 rounded-2xl p-8 transition-all duration-300 overflow-hidden"
            >
              {/* Background number */}
              <div className="absolute top-4 right-6 text-[7rem] font-black text-white/[0.03] leading-none select-none pointer-events-none">
                {idx + 1}
              </div>

              {/* Step number badge */}
              <div className="inline-flex items-center gap-2 bg-[#c9a55a]/10 border border-[#c9a55a]/20 rounded-full px-3 py-1 mb-6">
                <span className="text-[#c9a55a] text-xs font-bold tracking-widest">{step.num}</span>
              </div>

              <div className="w-12 h-12 flex items-center justify-center bg-[#0d0d0d] border border-white/10 group-hover:border-[#c9a55a]/30 rounded-xl mb-5 transition-colors">
                <i className={`${step.icon} text-[#c9a55a] text-xl`} />
              </div>

              <h3 className="text-white font-black text-xl mb-3">{step.title}</h3>
              <p className="text-white/50 text-sm leading-relaxed mb-5">{step.desc}</p>

              <div className="flex items-center gap-2 border-t border-white/8 pt-4">
                <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-arrow-right-s-line text-[#c9a55a] text-sm" />
                </div>
                <span className="text-[#c9a55a] text-xs font-semibold">{step.detail}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
